module.exports = __webpack_public_path__ + "img/logo.c201d280.png";